import { render, staticRenderFns } from "./ProductFilterSample.vue?vue&type=template&id=18f61ad6&"
import script from "./ProductFilterSample.vue?vue&type=script&lang=js&"
export * from "./ProductFilterSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports